import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from './contexts/AuthContext';
import {
    Box,
    Button,
    TextField,
    Typography,
    Container,
    Paper,
    Snackbar,
    Alert,
} from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledPaper = styled(Paper)(({ theme }) => ({
    marginTop: theme.spacing(8),
    padding: theme.spacing(4),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: "rgba(255, 255, 255, 0.9)",
    borderRadius: "10px",
    boxShadow: "0 8px 32px 0 rgba(31, 38, 135, 0.37)",
}));

const StyledForm = styled("form")(({ theme }) => ({
    width: "100%",
    marginTop: theme.spacing(1),
}));

const StyledButton = styled(Button)(({ theme }) => ({
    margin: theme.spacing(3, 0, 2),
    backgroundColor: "#1976d2",
    "&:hover": {
        backgroundColor: "#115293",
    },
}));

export default function BurcyHome() {
    const { login, user } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const [form, setForm] = useState({
        username: "",
        password: "",
    });
    const [formErrors, setFormErrors] = useState({});
    const [loading, setloading] = useState(false);
    const [message, setmessage] = useState("");
    const [stated, setstated] = useState("error");
    const [open, setOpen] = useState(false);

    useEffect(() => {
        // If user is already logged in, redirect to home
        if (user) {
            navigate('/', { replace: true });
        }
    }, [user, navigate]);

    const handleClicksnack = () => {
        setOpen(true);
    };

    const handleClosesnack = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpen(false);
    };

    const validate = () => {
        const errors = {};
        if (!form.username) errors.username = "Username is required";
        if (!form.password) errors.password = "Password is required";
        return errors;
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        const errors = validate();
        if (Object.keys(errors).length > 0) {
            setFormErrors(errors);
            return;
        }

        setloading(true);
        try {
            const result = await login({
                email: form.username,
                password: form.password,
            });

            if (result.success) {
                // Get the redirect path from location state or default to '/'
                const from = location.state?.from || '/';
                
                navigate(from, { replace: true });
                window.location.reload()
            } else {
                setmessage(result.error || "Login failed");
                setstated("error");
                handleClicksnack();
            }
        } catch (error) {
            setmessage("Network error. Please try again.");
            setstated("error");
            handleClicksnack();
        } finally {
            setloading(false);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({
            ...prev,
            [name]: value,
        }));
        // Clear error when user starts typing
        if (formErrors[name]) {
            setFormErrors((prev) => ({
                ...prev,
                [name]: "",
            }));
        }
    };

    return (
        <Container component="main" maxWidth="xs">
            <StyledPaper elevation={6}>
                <Typography component="h1" variant="h5">
                    Sign in
                </Typography>
                <StyledForm onSubmit={handleLogin}>
                 <TextField
                        variant="outlined"
                        margin="normal"
                 required
                        fullWidth
                     id="username"
                        label="Username"
                        name="username"
                        autoComplete="username"
                        autoFocus
                        value={form.username}
                        onChange={handleChange}
                        error={!!formErrors.username}
                        helperText={formErrors.username}
                    />
                 <TextField
                        variant="outlined"
                        margin="normal"
                 required
                        fullWidth
                        name="password"
                        label="Password"
                        type="password"
                     id="password"
                        autoComplete="current-password"
                        value={form.password}
                        onChange={handleChange}
                        error={!!formErrors.password}
                        helperText={formErrors.password}
                    />
                    <StyledButton
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        disabled={loading}
                    >
                        {loading ? "Signing in..." : "Sign In"}
                    </StyledButton>
                </StyledForm>

           
            </StyledPaper>


            <Snackbar
                open={open}
                autoHideDuration={6000}
                onClose={handleClosesnack}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
                <Alert
                    onClose={handleClosesnack}
                    severity={stated}
                    sx={{ width: "100%" }}
                >
                    {message}
                </Alert>
            </Snackbar>
        </Container>
    );
}
